<template>
  <section class="register-2">
    <div class="container-scroller">
      <div class="container-fluid page-body-wrapper full-page-wrapper">
        <div
          class="content-wrapper d-flex align-items-stretch auth auth-img-bg"
          style="overflow: hidden"
        >
          <div class="row flex-grow">
            <div class="col-lg-6 align-items-center justify-content-center register-tabs">
              <div class="auth-form-transparent text-left p-3">
                <div class="brand-logo">
                  <img :src="require('@/assets/images/logo2.png')" alt="logo" />
                </div>
                <h4>{{ $t('register.title') }}</h4>
                <h6 class="font-weight-light mb-4">{{ $t('register.subtitle') }}</h6>
                <b-alert v-model="isError" variant="danger">{{ error }}</b-alert>
                <b-tabs class="tab-solid tab-solid-primary" justified>
                  <b-tab active>
                    <template slot="title">{{ $t('roles.OEE_USER') }}</template>
                    <smart-oee-user-register-form
                      @submit="submitUserForm"
                    ></smart-oee-user-register-form>
                    <div class="text-center mt-4 font-weight-light">
                      {{ $t('register.form.footer.accountMsg') }}
                      <router-link to="/login" class="text-primary">
                        {{ $t('register.form.footer.loginLink') }}
                      </router-link>
                    </div>
                  </b-tab>
                  <b-tab>
                    <template slot="title">{{ $t('roles.OEE_PM') }}</template>
                    <smart-oee-pm-register-form @submit="submitPmForm"></smart-oee-pm-register-form>
                    <div class="text-center mt-4 font-weight-light">
                      {{ $t('register.form.footer.accountMsg') }}
                      <router-link to="/login" class="text-primary">
                        {{ $t('register.form.footer.loginLink') }}
                      </router-link>
                    </div>
                  </b-tab>
                </b-tabs>
              </div>
            </div>
            <div class="col-lg-6 register-half-bg d-flex flex-row">
              <p class="text-white font-weight-medium text-center flex-grow align-self-end">
                Copyright &copy; {{ date }} All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import registerUserMutation from '@/api/user/mutations/registerUser.gql';
import registerPmMutation from '@/api/user/mutations/registerPm.gql';
export default {
  name: 'SmartOeeRegisterMany',
  data() {
    return {
      registerError: '',
    };
  },
  computed: {
    date() {
      return new Date().getFullYear();
    },
    isError() {
      return !!this.registerError;
    },
    error() {
      return this.registerError;
    },
  },
  methods: {
    submitUserForm(form) {
      this.registerError = '';

      this.$apollo
        .mutate({
          mutation: registerUserMutation,
          variables: {
            firstName: form.name,
            lastName: form.surname,
            email: form.email,
            phone: form.phone,
          },
        })
        .then(() => {
          this.$store.commit('SET_PROCESSING', false);
          this.$router.push({ name: 'VerifyEmail' });
        })
        .catch((e) => {
          this.$store.commit('SET_PROCESSING', false);
          this.registerError = e.message;
        });
    },
    submitPmForm(form) {
      this.registerError = '';

      this.$apollo
        .mutate({
          mutation: registerPmMutation,
          variables: {
            firstName: form.name,
            lastName: form.surname,
            email: form.email,
            phone: form.phone,
            orgName: form.company,
            okpo: form.okpo,
          },
        })
        .then(() => {
          this.$store.commit('SET_PROCESSING', false);
          this.$router.push({ name: 'VerifyEmail' });
        })
        .catch((e) => {
          this.$store.commit('SET_PROCESSING', false);
          this.registerError = e.message;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.register-tabs {
  margin-top: 0.5rem;
}
</style>
